import React from 'react';

interface LastViewedAtContextType {
  getLastViewedAt: (
    type:
      | 'report'
      | 'dashboard'
      | 'wallboard'
      | 'workspace'
      | 'targetsApp'
      | 'scorecard'
      | 'board'
      | 'executivePortal',
    typeId: string,
  ) => string | undefined;
}

const LastViewedAtContext = React.createContext<LastViewedAtContextType>({
  getLastViewedAt: () => {
    return undefined;
  },
});

export default LastViewedAtContext;
